import React from 'react';
import type { SvgProps } from 'react-native-svg';
import { ClipPath, Defs, G, Path, Rect, Svg } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import { getPaymentBadgeColors } from './paymentBadgeColors';

export interface CashAppIconProps extends SvgProps {
  width?: number;
  height?: number;
  selected?: boolean;
}

const CashAppIcon: React.FC<CashAppIconProps> = ({
  width = 38,
  height = 24,
  selected = false,
  ...props
}) => {
  const { theme: colors } = useUnistyles();
  const { background, foreground } = getPaymentBadgeColors(selected);

  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 38 24"
      fill="none"
      {...props}
    >
      <G clipPath="url(#clip0)">
        <Path
          d="M35 0H3C1.34315 0 0 1.34315 0 3V21C0 22.6569 1.34315 24 3 24H35C36.6569 24 38 22.6569 38 21V3C38 1.34315 36.6569 0 35 0Z"
          fill={colors[background]}
        />
        <Path
          d="M25.7611 7.02489C25.4601 6.19716 24.8087 5.54759 23.9813 5.24644C23.2179 5 22.5231 5 21.1125 5H16.8765C15.4774 5 14.7708 5 14.0191 5.23243C13.1896 5.53577 12.5381 6.19016 12.2393 7.01963C12 7.77864 12 8.47855 12 9.87838V14.1212C12 15.528 12 16.2231 12.2323 16.9821C12.5333 17.8098 13.1848 18.4594 14.0121 18.7606C14.7708 19 15.4704 19 16.8717 19H21.1169C22.5231 19 23.2227 19 23.9765 18.7676C24.806 18.4664 25.4601 17.8125 25.7607 16.9826C26 16.2235 26 15.5236 26 14.1216V9.8902C26 8.48337 26 7.78345 25.7607 7.02445L25.7611 7.02489ZM22.163 9.72868L21.6183 10.2714C21.5089 10.3717 21.3405 10.3739 21.2285 10.2758C20.7021 9.83373 20.0367 9.58948 19.3507 9.58729C18.7832 9.58729 18.2179 9.7742 18.2179 10.2942C18.2179 10.8186 18.8239 10.9941 19.5235 11.2563C20.7494 11.6669 21.7636 12.1795 21.7636 13.381C21.7636 14.6898 20.7494 15.588 19.093 15.686L18.9403 16.3881C18.9127 16.5203 18.7968 16.614 18.6625 16.614H17.6164L17.5639 16.6096C17.409 16.5755 17.311 16.4205 17.3429 16.2656L17.507 15.5245C16.8778 15.3674 16.2994 15.0505 15.8252 14.6079V14.6009C15.7158 14.4915 15.7158 14.3138 15.8252 14.2044L16.4084 13.6388C16.52 13.5364 16.691 13.5364 16.8004 13.6388C17.3315 14.1404 18.0425 14.4206 18.7784 14.4092C19.537 14.4092 20.0433 14.0879 20.0433 13.5793C20.0433 13.0707 19.5305 12.9385 18.5623 12.576C17.5345 12.2088 16.5615 11.6892 16.5615 10.4741C16.5615 9.06291 17.7327 8.37437 19.1227 8.31047L19.2684 7.59217C19.296 7.45998 19.4141 7.36631 19.5489 7.36893H20.5858L20.6448 7.37594C20.7953 7.41008 20.8955 7.55584 20.8614 7.7086L20.7043 8.50875C21.2285 8.68209 21.7251 8.95785 22.149 9.3181L22.1626 9.33167C22.2719 9.4481 22.2719 9.62362 22.1626 9.72824L22.163 9.72868Z"
          fill={colors[foreground]}
        />
      </G>
      <Defs>
        <ClipPath id="clip0">
          <Rect width="38" height="24" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};

CashAppIcon.displayName = 'CashAppIcon';
export { CashAppIcon };
